import BlogDetail from "../../../commonComponents/blogDetail";

const BlogAudioLayoutContainer = () => {
  return <BlogDetail type="audio" />;
};

export default BlogAudioLayoutContainer;
